import React from "react";

import { useCourier } from "@/context/Courier.context";
import { Modal } from "@/components/common";

import { Form, Formik } from "formik";
import { useParcels } from "@/context/Parcels.context";
import { useMakeDeliverytRequest } from "@/api/useMakeDeliveryRequest";
import { useTheme } from "@/context/Theme.context";
import { Theme } from "@/enums";

const CourierModal = () => {
  const theme = useTheme();

  const {
    courierSteps,
    courierModalOpen,
    closeModal,
    setCourierStep,
    setDeliveryRequestStatus,
  } = useCourier();

  const { parcelId } = useParcels();
  const makeDeliveryRequest = useMakeDeliverytRequest();

  const handleSubmit = async (data: any) => {
    await makeDeliveryRequest({
      shipmentId: parcelId,
      addressDeliveryId: data?.addressDeliveryId.id,
      deliveryOptionId:
        theme === Theme.GEORGIA ? 2 : data?.deliveryOptionId?.id,
    }).then((response) => {
      if (
        response?.data?.data?.completed &&
        data?.nationalDeliveryPayTypeId === 1
      ) {
        setCourierStep("delivery-payment");
        setDeliveryRequestStatus(true);
      } else if (response?.data?.data?.completed) {
        setDeliveryRequestStatus(true);
        closeModal();
      }
    });
  };

  return (
    <Modal
      title={courierSteps?.stepName}
      titleClassNames="uppercase"
      className="max-h-[95vh] min-w-[45.625rem]"
      headerPaddings="!px-[30px]"
      paddings="!px-0"
      isOpen={courierModalOpen}
      closeModal={closeModal}
      showCloseIcon
    >
      <Formik
        initialValues={{
          addressDeliveryId: null,
          deliveryOptionId: theme === Theme.GEORGIA ? 2 : null,
        }}
        // validationSchema={courierSteps?.validationSchema || {}}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form>
            <div>{courierSteps.component}</div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default CourierModal;
